import React from 'react';
import { Route, Redirect } from "react-router-dom";
import useSession from 'Utils/Hooks/useSession';

/**
 * @param {{component:React.Component, appProps:any, ...rest:any}}
 * @param component Component to render if criteria is met.
 * @param appProps Additional props to pass to the component.
 * @param rest RouteProps
 */
export default function ValidUserRoute({ component: C, appProps, ...rest }) {

  const { session } = useSession();
  const isEnrolled = session && !session.isExpired && session.isVipEnrolled;
  return <Route
        {...rest}
        render={props =>
          isEnrolled
            ? <C {...props} {...appProps} />
            : <Redirect
                to='/dashboard'
              />}
      />
}